module.exports = __webpack_public_path__ + "img/Entia-Lineas-de-transmision-distribucion-electrica-10.7da81a36.webp";